export const cloud_intro = {
  title: "GLIFOS - cloud",
  backgroundClass: "bg-atardecer",
  description: `Ofrecemos la posibilidad de contratar nuestros sistemas en la nube como <i>Software as a Service</i>, al aplicar una infraestructura <i>multi tenant</i> optimizada nos permite ofrecer un menor precio en comparación de un licenciamiento convencional. Esto también facilita el proceso de actualización y mantenimiento de los sistemas ya que nos encargamos completamente del soporte de la infraestructura y respaldo de la información, la institución únicamente se preocupa por utilizar el sistema.`,
  primaryButton: {
    text: "Solicite una cotización",
    link: "#contactus",
  },
};
export const cloud_intro_archive = {
  title: "GLIFOS - cloud (for Archives)",
  backgroundClass: "bg-atardecer",
  description: `Ofrecemos la posibilidad de contratar infraestructura para nuestras licencias en la nube como <i>Infrastructure as a Service</i>, 
  lo que permite ágilmente implementar una solución de software que soporta la gestión del Departamento de Archivo. Esto también facilita el proceso de actualización y mantenimiento de los sistemas 
  ya que al nosotros proveer la infraestructura que soporta el sistema, tenemos una acceso más inmediato a dar soporte sobre el uso de la misma.`,
  primaryButton: {
    text: "Solicite una cotización",
    link: "#contactus",
  },
};
export const cloud_features_archive = {
  backgroundColor: "#fbf9f8",
  columnCount: 3,
  columns: [
    {
      title: `Soporte agilizado`,
      body: `<p>Al tener acceso más inmediato a la infraestructura y software, nos facilita proporcionar soporte a nuestros clientes al ahorrar tiempos de coordinación para accesos a los servidores.</p>`,
    },
    {
      title: `Simplicidad para el Departamento de Archivo`,
      body: `<p>No es necesario que el departamento de Archivo tenga personal de su departamento de TI dedicado para el soporte de la infraestructura ya que al ser proveída por nosotros, los usuarios únicamente se preocupan en utilizar el sistema.</p>`,
    },
    {
      title: `Un partner de su Departamento de TI`,
      body: `<p>Nos encargamos de proveer los recursos al departamento de TI, dimensionando las necesidades que requiere la solución. De ser solicitado podemos proveer todo el soporte necesario para 
      la correcta administración y servicio de la Infraestructura a un costo muy bajo, siendo el apoyo del Departamento de TI para crecer sin aumentar la complejidad del departamento.</p>`,
    },
  ],
};


export const cloud_features = {
  backgroundColor: "#fbf9f8",
  columnCount: 3,
  columns: [
    {
      title: `Soporte agilizado`,
      body: `<p>Al estar encargados totalmente de la infraestructura y software, nos facilita proporcionar soporte a nuestros clientes al ahorrar tiempos de coordinación para accesos a los servidores.</p>`,
    },
    {
      title: `Simplicidad para la biblioteca`,
      body: `<p>No es necesario que la biblioteca tenga un departamento de IT dedicado para el soporte de la infraestructura ya que esta tarea es relegada a nosotros, los usuarios únicamente se preocupan en utilizar el sistema.</p>`,
    },
    {
      title: `Respaldo y restauración`,
      body: `<p>Nos encargamos de la elaboración de respaldos de forma periódica y resguárdalos en servicios en la nube con toda la seguridad respaldada por los proveedores de nube. Los procesos de restauración en caso de contingencia son más agiles al tener una infraestructura en la nube.</p>`, 
    }
  ],
};